import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { Button, Tag } from "@livechat/design-system-react-components";

import { IntegrationCard } from "components/integration-card/IntegrationCard";
import { SettingsRoutes } from "routes/settings/constants";
import {
  IApplication,
  IWithApplicationsState,
  canManageApplications,
  isApplicationInstalled,
} from "store/entities/applications";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-named-as-default
import ActionsDropdown from "./ActionsDropdown";
import ApplicationIcon from "./ApplicationIcon";

interface IProps {
  application: IApplication;
  hideInstalledBadge?: boolean;
}

const ApplicationItem: React.FC<IProps> = ({ application, hideInstalledBadge }) => {
  const history = useHistory();
  const canManageApps = useSelector(canManageApplications);

  const isInstalled = useSelector((state: IWithApplicationsState) => isApplicationInstalled(state, application?.id));

  const { name, description, icons, slug, id } = application;

  const showInstalledBadge = isInstalled && !hideInstalledBadge;
  const openApplicationSettings = (): void => {
    const settingsUrl = `${SettingsRoutes.Integrations}/apps/${slug || id}`;
    history.push(settingsUrl);
  };
  return (
    <IntegrationCard
      icon={<ApplicationIcon id={id} name={name} icons={icons} />}
      title={name}
      titleBadge={showInstalledBadge && <Tag kind="success">Installed</Tag>}
      description={description || "-"}
      rightNodes={
        canManageApps && (
          <>
            <Button kind="secondary" onClick={openApplicationSettings}>
              Settings
            </Button>
            <ActionsDropdown application={application} />
          </>
        )
      }
    />
  );
};

export default ApplicationItem;
